
  (function () {
    'use strict';

    var el = document.querySelector('#lp-8051416891482');
    if (!el || el.dataset.on) return;
    el.dataset.on = '1';

    var $ = function (s) {
      return el.querySelector(s);
    };

    var $$ = function (s) {
      return Array.prototype.slice.call(el.querySelectorAll(s));
    };

    var form = $('form');
    var btn = $('[data-lp-btn]');
    var txt = $('[data-lp-txt]');
    var qtyIn = $('[data-lp-qty]');
    var stat = $('[data-lp-status]');
    var tiers = $$('[data-lp-tier]');
    var giftBox = $('[data-lp-gift]');
    var giftCount = $('[data-lp-gift-count]');
    var giftValue = $('[data-lp-gift-value]');
    var giftImg = $('[data-lp-gift-img]');
    var giftHalf = $$('[data-lp-gift-half]');
    var AFTER = el.dataset.after || 'drawer';
    var busy = false;

    var closeSheet = function () {
      return false;
    };

    function say(m) {
      if (stat) stat.textContent = m;
    }

    function jumpToOffer() {
      var offer = $('.lp__offer') || el;
      offer.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });

      setTimeout(function () {
        if (btn && !btn.disabled) {
          btn.focus({
            preventScroll: true,
          });
        }
      }, 700);
    }

    function safe(fn) {
      try {
        fn();
      } catch (e) {
        console.warn('[banisti]', e);
      }
    }

    function lockScroll() {
      var sw = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';

      if (sw > 0) {
        document.body.style.paddingRight = sw + 'px';
      }
    }

    function unlockScroll() {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }

    var CART_SECTIONS = [
      'cart-drawer',
      'cart-icon-bubble',
      'cart-notification-product',
      'cart-notification-button',
      'cart-live-region-text',
    ];

    function cartEl() {
      return document.querySelector('cart-drawer, cart-notification');
    }

    function sectionIds() {
      var c = cartEl();
      var ids = [];

      if (c && typeof c.getSectionsToRender === 'function') {
        try {
          ids = c.getSectionsToRender().map(function (s) {
            return s.id;
          });
        } catch (e) {}
      }

      CART_SECTIONS.forEach(function (id) {
        if (ids.indexOf(id) < 0) ids.push(id);
      });

      return ids;
    }

    function clearEmpty() {
      var nodes = document.querySelectorAll('cart-drawer,cart-drawer-items,.drawer__inner,.cart-drawer');

      Array.prototype.forEach.call(nodes, function (n) {
        n.classList.remove('is-empty');
      });
    }

    function openCart() {
      var c = cartEl();

      if (c && typeof c.open === 'function') {
        c.open();
        return;
      }

      var t = document.querySelector(
        '[data-cart-drawer-toggle],[data-drawer-open="cart"],.js-drawer-open-cart,#cart-icon-bubble,[aria-controls="CartDrawer"]'
      );

      if (t && !t.closest('[data-lp]')) {
        t.click();
      } else {
        window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
      }
    }

    function refreshTheme() {
      if (typeof window.banistiRefreshCart === 'function') {
        window.banistiRefreshCart();
      }

      ['cart:refresh', 'cart:updated', 'cart:change', 'cart:build'].forEach(function (n) {
        document.dispatchEvent(
          new CustomEvent(n, {
            bubbles: true,
          })
        );
      });
    }

    function paintCart(data) {
      var c = cartEl();

      if (c && data && data.sections && typeof c.renderContents === 'function') {
        try {
          c.renderContents(data);
        } catch (e) {
          console.warn('[banisti] renderContents', e);
        }
      }

      refreshTheme();

      [0, 80, 350].forEach(function (ms) {
        setTimeout(clearEmpty, ms);
      });
    }

    function addToCart() {
      if (!btn || btn.disabled || busy) return;

      busy = true;

      var old = txt ? txt.textContent : '';

      btn.disabled = true;
      btn.classList.remove('ok', 'err');

      if (txt) {
        txt.textContent = 'Añadiendo...';
      }

      var qty = 1;

      var idf = form && form.querySelector('[name="id"]');
      var id = idf ? idf.value : '';

      if (!id || !form) {
        if (form) form.submit();
        busy = false;
        return;
      }

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      function reset(cls, msg, ms) {
        btn.classList.add(cls);

        if (txt) {
          txt.textContent = msg;
        }

        say(msg);

        setTimeout(function () {
          btn.classList.remove(cls);
          btn.disabled = false;

          if (txt) {
            txt.textContent = old;
          }

          busy = false;
        }, ms);
      }

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [
            {
              id: Number(id),
              quantity: qty,
            },
          ],
          sections: sectionIds(),
          sections_url: window.location.pathname,
        }),
      })
        .then(function (r) {
          return r.json().then(function (data) {
            return {
              ok: r.ok,
              data: data,
            };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            reset('err', (res.data && (res.data.description || res.data.message)) || 'No se ha podido añadir', 2800);
            return;
          }

          if (AFTER === 'cart') {
            window.location.href = root + 'cart';
            return;
          }

          paintCart(res.data);

          var wasSheet = closeSheet();

          if (AFTER === 'drawer') {
            setTimeout(openCart, wasSheet ? 220 : 60);
          }

          reset('ok', 'Añadido al carrito', 2200);
        })
        .catch(function (err) {
          console.error('[banisti] cart/add:', err);
          reset('err', 'Error de conexión. Inténtalo de nuevo.', 2800);
        });
    }

    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addToCart();
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart();
      });
    }

    function pick(t) {
      if (!t) return;

      tiers.forEach(function (x) {
        x.classList.toggle('on', x === t);
      });

      var r = t.querySelector('input');

      if (r) {
        r.checked = true;
      }

      if (qtyIn) {
        qtyIn.value = '1';
      }

      var idField = form && form.querySelector('[name="id"]');
      if (idField) idField.value = t.getAttribute('data-vv-variant') || idField.value;
      if (!giftBox) return;

      var gn = parseInt(t.getAttribute('data-gift'), 10) || 0;

      if (gn > 0) {
        giftBox.style.display = '';

        if (giftCount) {
          giftCount.textContent = gn;
        }

        var gv = t.getAttribute('data-giftval');

        if (giftValue && gv) {
          giftValue.textContent = gv;
        }

        var gi = t.getAttribute('data-giftimg');

        if (giftImg && gi) {
          giftImg.src = gi;
        }

        if (giftImg) {
          giftImg.classList.toggle('is-fill', gn >= 90);
        }

        var gh = t.getAttribute('data-gifthalf');

        if (gh) {
          giftHalf.forEach(function (e) {
            e.textContent = gh;
          });
        }
      } else {
        giftBox.style.display = 'none';
      }
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        pick(t);
      });
    });

    pick($('[data-lp-tier].on') || tiers[0]);

    safe(function () {
      var stage = $('[data-lp-stage]');
      var slides = $$('[data-lp-slide]');

      if (!stage || slides.length < 2) return;

      var thumbs = $$('[data-lp-th]');
      var dots = $$('[data-lp-dot]');
      var prev = $('[data-lp-prev]');
      var next = $('[data-lp-next]');
      var track = $('[data-lp-thumbs]');
      var tPrev = $('[data-lp-tprev]');
      var tNext = $('[data-lp-tnext]');
      var i = 0;
      var n = slides.length;

      function warm(k) {
        var t = slides[(k + n) % n];

        if (t && t.loading === 'lazy') {
          t.loading = 'eager';
        }
      }

      function centerThumb(k) {
        if (!track || !thumbs[k]) return;

        var t = thumbs[k];

        track.scrollTo({
          left: t.offsetLeft - (track.clientWidth - t.clientWidth) / 2,
          behavior: 'smooth',
        });
      }

      function go(k) {
        i = Math.max(0, Math.min(n - 1, k));

        slides.forEach(function (s, x) {
          s.classList.toggle('on', x === i);
        });

        dots.forEach(function (d, x) {
          d.classList.toggle('on', x === i);
        });

        thumbs.forEach(function (t, x) {
          t.classList.toggle('on', x === i);
        });

        stage.classList.toggle('has-badge', i <= 1);

        if (prev) {
          prev.hidden = i === 0;
        }

        if (next) {
          next.hidden = i === n - 1;
        }

        warm(i + 1);
        warm(i - 1);
        centerThumb(i);
      }

      warm(1);
      warm(-1);

      if (prev) {
        prev.addEventListener('click', function () {
          go(i - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          go(i + 1);
        });
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          go(parseInt(t.getAttribute('data-lp-th'), 10));
        });
      });

      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          go(parseInt(d.getAttribute('data-lp-dot'), 10));
        });
      });

      if (track && tPrev && tNext) {
        var syncNav = function () {
          var max = track.scrollWidth - track.clientWidth;

          if (max < 4) {
            tPrev.hidden = true;
            tNext.hidden = true;
            return;
          }

          var pos = Math.abs(track.scrollLeft);

          tPrev.hidden = pos < 4;
          tNext.hidden = pos > max - 4;
        };

        var step = function (dir) {
          var rtl = getComputedStyle(track).direction === 'rtl';

          var amount = track.clientWidth * 0.8 * dir;

          track.scrollBy({
            left: rtl ? -amount : amount,
            behavior: 'smooth',
          });
        };

        tPrev.addEventListener('click', function () {
          step(-1);
        });

        tNext.addEventListener('click', function () {
          step(1);
        });

        track.addEventListener('scroll', syncNav, {
          passive: true,
        });

        window.addEventListener('resize', syncNav);

        requestAnimationFrame(syncNav);
        setTimeout(syncNav, 400);
      }

      var x0 = null;
      var y0 = null;

      stage.addEventListener(
        'touchstart',
        function (e) {
          x0 = e.touches[0].clientX;
          y0 = e.touches[0].clientY;
        },
        {
          passive: true,
        }
      );

      stage.addEventListener(
        'touchend',
        function (e) {
          if (x0 === null) return;

          var dx = e.changedTouches[0].clientX - x0;

          var dy = e.changedTouches[0].clientY - y0;

          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
            go(dx > 0 ? i + 1 : i - 1);
          }

          x0 = y0 = null;
        },
        {
          passive: true,
        }
      );
    });

    safe(function () {
      var items = $$('[data-lp-fi]');

      items.forEach(function (item) {
        var b = item.querySelector('[data-lp-faq]');

        if (!b) return;

        b.addEventListener('click', function () {
          var willOpen = !item.classList.contains('open');

          items.forEach(function (o) {
            o.classList.remove('open');

            var ob = o.querySelector('[data-lp-faq]');

            if (ob) {
              ob.setAttribute('aria-expanded', 'false');
            }
          });

          if (willOpen) {
            item.classList.add('open');
            b.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });

    safe(function () {
      var mods = {};

      $$('[data-lp-abmodal]').forEach(function (m) {
        mods[m.getAttribute('data-lp-abmodal')] = m;
      });

      var openM = null;
      var lastFocus = null;

      function openModal(key) {
        var m = mods[key];

        if (!m) return;

        lastFocus = document.activeElement;
        openM = m;

        m.classList.add('open');
        el.classList.add('lp--modal-open');

        lockScroll();

        var x = m.querySelector('[data-lp-abclose]');

        setTimeout(function () {
          if (x) {
            x.focus({
              preventScroll: true,
            });
          }
        }, 50);
      }

      function closeModal() {
        if (!openM) return;

        openM.classList.remove('open');
        el.classList.remove('lp--modal-open');

        unlockScroll();

        if (lastFocus && lastFocus.focus) {
          lastFocus.focus({
            preventScroll: true,
          });
        }

        openM = null;
      }

      $$('[data-lp-abopen]').forEach(function (b) {
        b.addEventListener('click', function () {
          openModal(b.getAttribute('data-lp-abopen'));
        });
      });

      $$('[data-lp-abclose]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          closeModal();
        });
      });

      Object.keys(mods).forEach(function (k) {
        mods[k].addEventListener('click', function (e) {
          if (e.target === mods[k]) {
            closeModal();
          }
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && openM) {
          closeModal();
        }
      });
    });

    /* ══ הסתרת הסרגל הצף כשמגירת העגלה מכסה אותו ══
       עיקרון בטיחות: מצב ברירת המחדל הוא שהסרגל מוצג. הוא מוסתר רק
       כשנמדד שמשהו מהעגלה יושב מעליו, וכל עוד הוא מוסתר רץ שומר
       שבודק שוב ומשחרר ברגע שהכיסוי נעלם. כשל של המנגנון מחזיר את
       הסרגל, ולא מעלים אותו. */
    safe(function () {
      var fabEl = $('[data-lp-fab]');
      if (!fabEl) return;
      var sel = 'cart-drawer,cart-notification,.cart-drawer,.drawer--cart,#CartDrawer';
      var nodes = Array.prototype.slice.call(document.querySelectorAll(sel)).filter(function (n) {
        return !n.closest('[data-lp]');
      });
      if (!nodes.length) return;

      var root = document.documentElement;
      var guard = null;

      function covered() {
        try {
          var r = fabEl.getBoundingClientRect();
          var vw = window.innerWidth || document.documentElement.clientWidth || 0;
          var vh = window.innerHeight || document.documentElement.clientHeight || 0;
          var x = r.width ? r.left + r.width / 2 : vw / 2;
          var y = r.height ? r.top + r.height / 2 : vh - 40;
          if (!(x > 0 && y > 0 && x < vw && y < vh)) {
            x = vw / 2;
            y = vh - 40;
          }
          var top = document.elementFromPoint(x, y);
          if (!top) return false;
          for (var i = 0; i < nodes.length; i++) {
            if (nodes[i] === top || nodes[i].contains(top)) return true;
          }
          return false;
        } catch (e) {
          /* בכל תקלה מחזירים את הסרגל */
          return false;
        }
      }

      function sync() {
        var open = covered();
        if (root.classList.contains('lp-cart-open') !== open) root.classList.toggle('lp-cart-open', open);
        /* השומר רץ רק כל עוד הסרגל מוסתר, ונעצר מיד כשהוא חוזר */
        if (open && !guard) {
          guard = setInterval(function () {
            if (!covered()) {
              root.classList.remove('lp-cart-open');
              clearInterval(guard);
              guard = null;
            }
          }, 400);
        } else if (!open && guard) {
          clearInterval(guard);
          guard = null;
        }
      }

      function later() {
        setTimeout(sync, 120);
        setTimeout(sync, 500);
      }
      document.addEventListener('click', later);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') later();
      });
      ['cart:refresh', 'cart:updated', 'cart:change', 'cart:build'].forEach(function (n) {
        document.addEventListener(n, later);
      });
      nodes.forEach(function (n) {
        n.addEventListener('transitionend', function () {
          setTimeout(sync, 30);
        });
      });
      sync();
    });

    safe(function () {
      var fab = $('[data-lp-fab]');
      var cta = $('.lp__cta');
      var end = $('.lp__only-cta');

      if (!fab || !cta || !('IntersectionObserver' in window)) {
        return;
      }

      var pastTop = false;
      var endVisible = false;

      function sync() {
        fab.classList.toggle('on', pastTop && !endVisible);
      }

      new IntersectionObserver(
        function (en) {
          var e = en[0];

          pastTop = !e.isIntersecting && e.boundingClientRect.bottom < 0;

          sync();
        },
        {
          threshold: 0,
        }
      ).observe(cta);

      if (end) {
        new IntersectionObserver(
          function (en) {
            endVisible = en[0].isIntersecting;

            sync();
          },
          {
            threshold: 0,
            rootMargin: '0px 0px -40px 0px',
          }
        ).observe(end);
      }
    });

    safe(function () {
      var vs = $('[data-lp-vs]');

      if (!vs) return;

      if (!('IntersectionObserver' in window)) {
        vs.classList.add('on');
        return;
      }

      var io = new IntersectionObserver(
        function (en) {
          if (!en[0].isIntersecting) {
            return;
          }

          vs.classList.add('on');
          io.disconnect();
        },
        {
          threshold: 0.3,
        }
      );

      io.observe(vs);
    });

    safe(function () {
      var b = $('[data-lp-revjump]');

      if (!b) return;

      var SEL = [
        '#shopify-product-reviews',
        '.spr-container',
        '#judgeme_product_reviews',
        '.jdgm-rev-widget',
        '.jdgm-widget',
        '.yotpo-widget-instance',
        '.yotpo-main-widget',
        '#looxReviews',
        '.loox-reviews-default',
        '#stamped-reviews-widget',
        '.stamped-reviews-widget',
        '.okeReviews',
        '.ryviu-widget',
        '[id^="shopify-section"][id*="review"]',
        '[class*="review"][class*="section"]',
      ];

      function usable(n) {
        if (!n || el.contains(n)) {
          return false;
        }

        if (n.closest('[data-lp]')) {
          return false;
        }

        return !!(n.offsetWidth || n.offsetHeight || n.getClientRects().length);
      }

      function find() {
        var manual = (b.getAttribute('data-lp-revjump') || '').trim();

        if (manual) {
          try {
            var m = document.querySelector(manual);

            if (usable(m)) {
              return m;
            }
          } catch (e) {
            console.warn('[banisti] reviews_target לא תקין:', manual);
          }
        }

        for (var i = 0; i < SEL.length; i++) {
          var list = document.querySelectorAll(SEL[i]);

          for (var j = 0; j < list.length; j++) {
            if (usable(list[j])) {
              return list[j];
            }
          }
        }

        return null;
      }

      b.addEventListener('click', function () {
        var t = find();

        if (!t) {
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth',
          });

          return;
        }

        var y = t.getBoundingClientRect().top + window.pageYOffset - 80;

        window.scrollTo({
          top: Math.max(0, y),
          behavior: 'smooth',
        });
      });
    });

    /* ══ מודאל פייסבוק ══ */
    safe(function () {
      var m = $('[data-lp-fbm]'),
        o = $('[data-lp-fb-open]'),
        c = $('[data-lp-fb-close]');
      if (!m || !o) return;
      var load = m.querySelector('[data-lp-load]');
      var body = m.querySelector('[data-lp-fbm-body]');
      var foot = m.querySelector('[data-lp-fbm-foot]');
      var ltxt = m.querySelector('[data-lp-load-txt]');
      var timers = [];
      function clearT() {
        timers.forEach(clearTimeout);
        timers = [];
      }
      function open() {
        m.classList.add('open');
        lockScroll();
        setTimeout(function () {
          if (c) c.focus({ preventScroll: true });
        }, 60);
        clearT();
        m.classList.remove('ready');
        if (load) load.hidden = false;
        if (body) body.hidden = true;
        if (foot) foot.hidden = true;
        if (ltxt) ltxt.textContent = 'Cargando comentarios';
        var rvRoot = el.querySelector('[data-rv-root]');
        if (rvRoot && rvRoot.__rvReset) rvRoot.__rvReset();
        timers.push(
          setTimeout(function () {
            if (ltxt) ltxt.textContent = 'Un momento';
          }, 1100)
        );
        timers.push(
          setTimeout(function () {
            if (load) load.hidden = true;
            if (body) body.hidden = false;
            if (foot) foot.hidden = false;
            m.classList.add('ready');
          }, 2500)
        );
      }
      function close() {
        clearT();
        m.classList.remove('open', 'ready');
        unlockScroll();
        o.focus({ preventScroll: true });
      }
      /* מאפשר לכפתור "הצגת נוספות" לסגור את החלונית אחרי שגיאה */
      var rvRootEl = el.querySelector('[data-rv-root]');
      if (rvRootEl) rvRootEl.__rvClose = close;
      o.addEventListener('click', open);
      if (c) c.addEventListener('click', close);
      m.addEventListener('click', function (e) {
        if (e.target === m) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && m.classList.contains('open')) close();
      });
    });

    /* ══ סרגל צף ══ */
    safe(function () {
      var fab = $('[data-lp-fab]');
      var cta = $('.lp__cta');
      var end = $('.lp__only-cta');
      if (!fab || !cta || !('IntersectionObserver' in window)) return;
      var pastTop = false,
        endVisible = false;
      function sync() {
        fab.classList.toggle('on', pastTop && !endVisible);
      }
      new IntersectionObserver(
        function (en) {
          var e = en[0];
          pastTop = !e.isIntersecting && e.boundingClientRect.bottom < 0;
          sync();
        },
        { threshold: 0 }
      ).observe(cta);
      if (end) {
        new IntersectionObserver(
          function (en) {
            endVisible = en[0].isIntersecting;
            sync();
          },
          { threshold: 0, rootMargin: '0px 0px -40px 0px' }
        ).observe(end);
      }
    });

    /* ══ כרטיס התוצאות · הפסים מתמלאים כשמגיעים אליו ══ */
    safe(function () {
      var vs = $('[data-lp-vs]');
      if (!vs) return;
      if (!('IntersectionObserver' in window)) {
        vs.classList.add('on');
        return;
      }
      var io = new IntersectionObserver(
        function (en) {
          if (!en[0].isIntersecting) return;
          vs.classList.add('on');
          io.disconnect();
        },
        { threshold: 0.3 }
      );
      io.observe(vs);
    });

    /* ══ רמז לחיצה · רק כשהאריחים במרכז המסך ══ */
    safe(function () {
      var grid = $('[data-lp-abgrid]');
      if (!grid) return;
      var hint = grid.querySelector('[data-lp-abhint]');
      if (!hint) return;
      var done = false,
        queued = false;

      /* האריחים חייבים להיות גלויים כמעט במלואם, והמרכז שלהם קרוב למרכז המסך */
      function centered() {
        var r = grid.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        if (!r.height || !vh) return false;
        var vis = Math.min(r.bottom, vh) - Math.max(r.top, 0);
        if (vis / Math.min(r.height, vh) < 0.9) return false;
        return Math.abs(r.top + r.height / 2 - vh / 2) <= vh * 0.16;
      }
      function stop() {
        window.removeEventListener('scroll', onMove);
        window.removeEventListener('resize', onMove);
      }
      function fire() {
        done = true;
        stop();
        hint.classList.add('on');
        setTimeout(function () {
          hint.classList.remove('on');
        }, 2000);
        setTimeout(function () {
          if (hint.parentNode) hint.parentNode.removeChild(hint);
        }, 2500);
      }
      function check() {
        queued = false;
        if (!done && centered()) fire();
      }
      function onMove() {
        if (queued || done) return;
        queued = true;
        requestAnimationFrame(check);
      }

      window.addEventListener('scroll', onMove, { passive: true });
      window.addEventListener('resize', onMove);
      check();
    });

    /* ══ קפיצה לסקשן הביקורות שלמטה בעמוד ══
       הסקשן הזה יושב מחוץ לסניפט, לכן מחפשים אותו בכל העמוד.
       אפשר לקבע יעד ידני במשתנה reviews_target למעלה. */
    safe(function () {
      var b = $('[data-lp-revjump]');
      if (!b) return;

      var SEL = [
        '#shopify-product-reviews',
        '.spr-container',
        '#judgeme_product_reviews',
        '.jdgm-rev-widget',
        '.jdgm-widget',
        '.yotpo-widget-instance',
        '.yotpo-main-widget',
        '#looxReviews',
        '.loox-reviews-default',
        '#stamped-reviews-widget',
        '.stamped-reviews-widget',
        '.okeReviews',
        '.ryviu-widget',
        '[id^="shopify-section"][id*="review"]',
        '[class*="review"][class*="section"]',
      ];

      function usable(n) {
        if (!n || el.contains(n)) return false;
        if (n.closest('[data-lp]')) return false;
        return !!(n.offsetWidth || n.offsetHeight || n.getClientRects().length);
      }
      function find() {
        var manual = (b.getAttribute('data-lp-revjump') || '').trim();
        if (manual) {
          try {
            var m = document.querySelector(manual);
            if (usable(m)) return m;
          } catch (e) {
            console.warn('[banisti] reviews_target לא תקין:', manual);
          }
        }
        for (var i = 0; i < SEL.length; i++) {
          var list = document.querySelectorAll(SEL[i]);
          for (var j = 0; j < list.length; j++) {
            if (usable(list[j])) return list[j];
          }
        }
        return null;
      }

      b.addEventListener('click', function () {
        var t = find();
        if (!t) {
          window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
          return;
        }
        var y = t.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      });
    });

    /* ══ ביקורות דף הפייסבוק · בתוך חלונית התגובות ══ */
    safe(function () {
      var rv = $('#rv-8051416891482');
      var ask = $('[data-rv-askmodal]');
      if (!rv && !ask) return;

      if (rv) {
        /* ── מיון אמיתי ──
           top = לפי מעורבות (מספר הריאקציות), לא לפי תאריך
           new = לפי תאריך, מהחדש לישן
           all = הסדר המקורי של הפיד */
        var list = rv.querySelector('[data-rv-list]');
        var items = Array.prototype.slice.call(rv.querySelectorAll('[data-rv-item]'));
        var n = function (el, a) {
          return parseInt(el.getAttribute(a), 10) || 0;
        };

        function applySort(mode) {
          if (!list) return;
          var arr = items.slice();
          arr.sort(function (a, b) {
            if (mode === 'top') {
              var d = n(b, 'data-rv-likes') - n(a, 'data-rv-likes');
              if (d) return d;
            } else if (mode === 'new') {
              var t = n(b, 'data-rv-date') - n(a, 'data-rv-date');
              if (t) return t;
            }
            return n(a, 'data-rv-i') - n(b, 'data-rv-i');
          });
          var frag = document.createDocumentFragment();
          arr.forEach(function (x) {
            frag.appendChild(x);
          });
          list.appendChild(frag);
          rv.setAttribute('data-rv-sorted', mode);
        }

        /* ── תפריט המיון ── */
        var sBtn = rv.querySelector('[data-rv-sortbtn]');
        var sMenu = rv.querySelector('[data-rv-menu]');
        var sLabel = rv.querySelector('[data-rv-sortlabel]');
        var opts = Array.prototype.slice.call(rv.querySelectorAll('[data-rv-sortopt]'));
        if (sBtn && sMenu) {
          var closeMenu = function () {
            sMenu.classList.remove('open');
            sBtn.setAttribute('aria-expanded', 'false');
          };
          sBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            var open = sMenu.classList.toggle('open');
            sBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          });
          opts.forEach(function (o) {
            o.addEventListener('click', function () {
              opts.forEach(function (x) {
                x.classList.remove('on');
                x.setAttribute('aria-checked', 'false');
              });
              o.classList.add('on');
              o.setAttribute('aria-checked', 'true');
              if (sLabel) sLabel.textContent = o.getAttribute('data-rv-sortname');
              applySort(o.getAttribute('data-rv-sortopt'));
              closeMenu();
            });
          });
          document.addEventListener('click', function (e) {
            if (!sMenu.contains(e.target) && !sBtn.contains(e.target)) closeMenu();
          });
          /* ברירת המחדל · האפשרות הראשונה בתפריט */
          if (opts.length) applySort(opts[0].getAttribute('data-rv-sortopt'));
        }

        /* ── רשימת העוקבים פרטית ── */
        var toast = rv.querySelector('[data-rv-toast]');
        var toastT = null;
        rv.querySelectorAll('[data-rv-priv]').forEach(function (b) {
          b.addEventListener('click', function () {
            if (!toast) return;
            toast.hidden = false;
            clearTimeout(toastT);
            toastT = setTimeout(function () {
              toast.hidden = true;
            }, 3200);
          });
        });

        /* ── Mostrar más reseñas · נכנס לטעינה ונשאר בה,
              כי אין דף נוסף לטעון בלי האפליקציה ── */
        var more = rv.querySelector('[data-rv-more]');
        if (more) {
          var moreTxt = more.querySelector('[data-rv-more-txt]');
          var loadWord = 'Cargando';
          var idleWord = 'Mostrar más reseñas';
          var dotsT = null;
          var errWord = 'Error de carga. Sigue leyendo en la web.';
          var failT = null;
          var shutT = null;
          more.addEventListener('click', function () {
            if (more.classList.contains('loading') || more.classList.contains('failed')) return;
            more.classList.add('loading');
            more.setAttribute('aria-busy', 'true');
            if (moreTxt) {
              var dots = 0;
              moreTxt.textContent = loadWord;
              clearInterval(dotsT);
              dotsT = setInterval(function () {
                dots = (dots + 1) % 4;
                moreTxt.textContent = loadWord + new Array(dots + 1).join('.');
              }, 420);
            }
            /* אחרי 2.5 שניות של ניסיון מציגים שגיאה, ואחרי 2 שניות
               נוספות סוגרים את החלונית וחוזרים לקריאה בדף */
            clearTimeout(failT);
            failT = setTimeout(function () {
              clearInterval(dotsT);
              dotsT = null;
              more.classList.remove('loading');
              more.classList.add('failed');
              more.removeAttribute('aria-busy');
              if (moreTxt) moreTxt.textContent = errWord;
              clearTimeout(shutT);
              shutT = setTimeout(function () {
                if (typeof rv.__rvClose === 'function') rv.__rvClose();
              }, 2000);
            }, 2500);
          });
          /* איפוס בכל פתיחה מחדש של החלונית · מונע טיימר שרץ לנצח */
          rv.__rvReset = function () {
            clearInterval(dotsT);
            dotsT = null;
            clearTimeout(failT);
            clearTimeout(shutT);
            more.classList.remove('loading', 'failed');
            more.removeAttribute('aria-busy');
            if (moreTxt) moreTxt.textContent = idleWord;
            if (toast) toast.hidden = true;
          };
        }
      }

      /* ── כל לחיצה על אהבתי / תגובה / שיתוף / לייקים שואלת על האפליקציה ── */
      if (!ask) return;
      var lastFocus = null;
      function openAsk() {
        lastFocus = document.activeElement;
        ask.classList.add('open');
        var no = ask.querySelector('[data-rv-askclose]');
        setTimeout(function () {
          if (no) no.focus({ preventScroll: true });
        }, 40);
      }
      function closeAsk() {
        ask.classList.remove('open');
        if (typeof ask.__askReset === 'function') {
          ask.__askReset();
        } else {
          var g = ask.querySelector('[data-rv-askgo]');
          if (g) {
            g.classList.remove('loading', 'failed');
            g.removeAttribute('aria-busy');
            var t = g.querySelector('[data-rv-gotxt]');
            if (t) t.textContent = 'Abrir la aplicación';
          }
        }
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }
      $$('[data-rv-ask]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openAsk();
        });
      });
      $$('[data-rv-askclose]').forEach(function (b) {
        b.addEventListener('click', closeAsk);
      });
      ask.addEventListener('click', function (e) {
        if (e.target === ask) closeAsk();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && ask.classList.contains('open')) closeAsk();
      });

      /* כפתור Abrir la aplicación · נכנס לטעינה. אם data-href מלא הוא גם פותח.
         כדי להפעיל: למלא את rv_fb_url במשתנים למעלה. */
      var go = ask.querySelector('[data-rv-askgo]');
      if (go) {
        var goTxt = go.querySelector('[data-rv-gotxt]');
        var goErr = 'No se pudo abrir. Sigue leyendo en la web.';
        var goFailT = null;
        var goShutT = null;

        /* ניקוי הטיימרים · נקרא גם מהסגירה הרגילה של החלונית */
        ask.__askReset = function () {
          clearTimeout(goFailT);
          clearTimeout(goShutT);
          go.classList.remove('loading', 'failed');
          go.removeAttribute('aria-busy');
          if (goTxt) goTxt.textContent = 'Abrir la aplicación';
        };

        go.addEventListener('click', function () {
          if (go.classList.contains('loading') || go.classList.contains('failed')) return;
          go.classList.add('loading');
          go.setAttribute('aria-busy', 'true');
          var href = go.getAttribute('data-href');
          if (href) {
            setTimeout(function () {
              window.open(href, '_blank', 'noopener');
            }, 400);
            return;
          }
          /* בלי כתובת אפליקציה · מנסים 2.5 שניות, מציגים שגיאה,
             ואחרי 2 שניות סוגרים גם את חלונית השאלה וגם את הביקורות */
          clearTimeout(goFailT);
          goFailT = setTimeout(function () {
            go.classList.remove('loading');
            go.classList.add('failed');
            go.removeAttribute('aria-busy');
            if (goTxt) goTxt.textContent = goErr;
            clearTimeout(goShutT);
            goShutT = setTimeout(function () {
              closeAsk();
              var root = el.querySelector('[data-rv-root]');
              if (root && typeof root.__rvClose === 'function') root.__rvClose();
            }, 2000);
          }, 2500);
        });
      }
    });

    safe(function () {
      var vids = $$('video');

      if (!vids.length || !('IntersectionObserver' in window)) {
        return;
      }

      /* חימום · rootMargin מרחיב את אזור הזיהוי מסך וחצי מראש, כך
         שהווידאו מתחיל להיטען בזמן שגוללים אליו ולא ברגע שמגיעים. */
      var warm = new IntersectionObserver(
        function (ens) {
          ens.forEach(function (en) {
            if (!en.isIntersecting) return;

            var v = en.target;

            if (v.preload !== 'auto') {
              v.preload = 'auto';

              if (typeof v.load === 'function') {
                v.load();
              }
            }

            warm.unobserve(v);
          });
        },
        {
          rootMargin: '150% 0px',
        }
      );

      var io = new IntersectionObserver(
        function (ens) {
          ens.forEach(function (en) {
            var v = en.target;

            if (en.isIntersecting) {
              var pr = v.play();

              if (pr && pr.catch) {
                pr.catch(function () {});
              }
            } else if (!v.paused) {
              v.pause();
            }
          });
        },
        {
          threshold: 0.15,
        }
      );

      vids.forEach(function (v) {
        warm.observe(v);

        io.observe(v);
      });
    });

    safe(function () {
      $$('[data-lp-jump]').forEach(function (j) {
        j.addEventListener('click', jumpToOffer);
      });
    });

    safe(function () {
      var openers = $$('[data-lp-sheet-open]');

      if (!openers.length) return;

      var sheet = $('[data-lp-sheet]');

      var body = $('[data-lp-sheet-body]');

      var offer = $('.lp__offer');

      var cta = $('.lp__cta');

      if (!sheet || !body || !offer || !cta) {
        openers.forEach(function (b) {
          b.addEventListener('click', jumpToOffer);
        });

        return;
      }

      var slotOffer = document.createComment('lp-offer');

      var slotCta = document.createComment('lp-cta');

      var isOpen = false;
      var lastFocus = null;

      function open() {
        if (isOpen) return;

        isOpen = true;
        lastFocus = document.activeElement;

        offer.parentNode.insertBefore(slotOffer, offer);

        cta.parentNode.insertBefore(slotCta, cta);

        body.appendChild(offer);
        body.appendChild(cta);

        body.scrollTop = 0;

        sheet.classList.add('open');
        el.classList.add('lp--modal-open');

        lockScroll();

        setTimeout(function () {
          var x = sheet.querySelector('[data-lp-sheet-close]');

          if (x) {
            x.focus({
              preventScroll: true,
            });
          }
        }, 60);
      }

      function close() {
        if (!isOpen) return false;

        isOpen = false;
        sheet.classList.remove('open');

        if (slotOffer.parentNode) {
          slotOffer.parentNode.insertBefore(offer, slotOffer);

          slotOffer.parentNode.removeChild(slotOffer);
        }

        if (slotCta.parentNode) {
          slotCta.parentNode.insertBefore(cta, slotCta);

          slotCta.parentNode.removeChild(slotCta);
        }

        el.classList.remove('lp--modal-open');

        unlockScroll();

        if (lastFocus && lastFocus.focus) {
          lastFocus.focus({
            preventScroll: true,
          });
        }

        return true;
      }

      closeSheet = close;

      openers.forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          open();
        });
      });

      $$('[data-lp-sheet-close]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          close();
        });
      });

      sheet.addEventListener('click', function (e) {
        if (e.target === sheet) {
          close();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          close();
        }
      });
    });
  })();
